import React from 'react';
import { useHistory } from 'react-router-dom';
import { FormattedMessage } from '../../util/reactIntl';
import owlImage from '../../assets/images/owl.png'
import IconCollection from '../IconCollection/IconCollection';
import classNames from 'classnames';
import student from '../../assets/images/owl.png';
import Button from '../Button/Button';
import { STUDENT, TUTOR } from '../../util/types';
import { createResourceLocatorString } from '../../util/routes';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';
import css from './ListingCompletePopup.module.css'

const ListingCompletePopup = (props) => {
    const { userType = TUTOR, values } = props;
    const { languageToLearn = [], languageToTeach: toTeach = [] } = values || {};
    const languagesToTeach = languageToLearn.map(item => item);

    const history = useHistory();
    const routeConfiguration = useRouteConfiguration();
    const handleSearchRedirect = () => {
        const filter = userType == TUTOR ? {["publicData.languageToLearn"]: toTeach[0]} : {["publicData.languageToTeach"]: languagesToTeach};
        return history.push(createResourceLocatorString('AlgoliaSearchPage', routeConfiguration, { userType: userType == TUTOR ? STUDENT : TUTOR }, { ...filter }));
    };
    const handleSyncmyCalendarRedirect = () => {
        return history.push(createResourceLocatorString('CronofyPage', routeConfiguration, {}, {}));
    };

    return (
        <>
            {userType == TUTOR ?
                <div className={css.mainContainer}>
                    <div className={css.congratulationsContainer}>
                        <div className={css.owlImage}>
                            <img src={owlImage} alt="owl" />
                        </div>
                        <h2 className={css.congratulationsHeading}>
                            <span className={css.highlight}><FormattedMessage id="ListingComplete.congratulations" /></span> <FormattedMessage id="ListingComplete.thisStep" />
                        </h2>
                        <p className={css.congratulationsSubtext}>
                            <FormattedMessage id="ListingCompleteTutor.youAre" />
                        </p>
                        <div className={css.stepsContainer}>
                            <div className={css.step}>
                                <div className={css.icon}>
                                    <IconCollection iconName="SUNGLASS" />
                                </div>
                                <h3><FormattedMessage id="ListingComplete.stepOne" /></h3>
                                <p><FormattedMessage id="ListingCompleteTutor.studentsWill" /></p>
                            </div>
                            <div className={css.step}>
                                <div className={classNames(css.messageIcon, css.icon)}>
                                    <IconCollection iconName="MESSAGE_ICON" />
                                </div>
                                <h3><FormattedMessage id="ListingComplete.stepTwo" /></h3>
                                <p><FormattedMessage id="ListingCompleteTutor.studentSessionRequest" /></p>
                            </div>
                            <div className={css.step}>
                                <div className={css.icon}>
                                    <IconCollection iconName="STAR_ICON" />
                                </div>
                                <h3><FormattedMessage id="ListingComplete.stepThree" /></h3>
                                <p><FormattedMessage id="ListingCompleteTutor.meetStudents" /></p>
                            </div>
                        </div>
                        <div className={css.tutorButtons}>
                            <Button className={css.viewMatchesButton} onClick={handleSearchRedirect}><FormattedMessage id="ListingComplete.myMatches" /></Button>
                            {/* <Button className={css.syncMyCalender} onClick={handleSyncmyCalendarRedirect}><FormattedMessage id="ListingCompleteTutor.syncMyCallender" /></Button> */}
                        </div>
                    </div>
                </div>
                :
                <div className={css.mainContainer}>
                    <div className={css.congratulationsContainer}>
                        <div className={css.owlImage}>
                            <img src={owlImage} alt="owl" />
                        </div>
                        <h2 className={css.congratulationsHeading}>
                            <span className={css.highlight}><FormattedMessage id="ListingComplete.congratulations" /></span> <FormattedMessage id="ListingComplete.thisStep" />
                        </h2>
                        <p className={css.congratulationsSubtext}>
                            <FormattedMessage id="ListingComplete.youAre" />
                        </p>
                        <div className={css.stepsContainer}>
                            <div className={css.step}>
                                <div className={css.icon}>
                                    <IconCollection iconName="SUNGLASS" />
                                </div>
                                <h3><FormattedMessage id="ListingComplete.stepOne" /></h3>
                                <p><FormattedMessage id="ListingComplete.tutorsWill" /></p>
                            </div>
                            <div className={css.step}>
                                <div className={classNames(css.messageIcon, css.icon)}>
                                    <IconCollection iconName="MESSAGE_ICON" />
                                </div>
                                <h3><FormattedMessage id="ListingComplete.stepTwo" /></h3>
                                <p><FormattedMessage id="ListingComplete.tutorsWill" /></p>
                            </div>
                            <div className={css.step}>
                                <div className={css.icon}>
                                    <IconCollection iconName="STAR_ICON" />
                                </div>
                                <h3><FormattedMessage id="ListingComplete.stepThree" /></h3>
                                <p><FormattedMessage id="ListingComplete.tutorsWill" /></p>
                            </div>
                        </div>
                        <div className={css.studentButtons}>
                            <Button className={css.viewMatchesButtonStudent} onClick={handleSearchRedirect}><FormattedMessage id="ListingComplete.myMatches" /></Button>
                        </div>
                    </div>
                </div>
            }
        </>
    );
};

export default ListingCompletePopup;
